import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setFieldValue from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SetFieldValue";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Checkbox, { CheckboxProps } from "@insite/mobius/Checkbox/Checkbox";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

const enum fields {
    label = "label"
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.label]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    signUpForNewsletter: state.components.contactUsForm.fieldValues["signUpForNewsletter"],
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface SignUpForNewsletterStyles {
    signUpForNewsletterCheckboxField?: CheckboxProps;
}

export const signUpForNewsletterStyles: SignUpForNewsletterStyles = {};

const styles = signUpForNewsletterStyles;
const SignUpForNewsletter: React.FC<Props> = ({ fields, signUpForNewsletter, setFieldValue }) => {
    const { label } = fields;
    const signUpForNewsletterChangeHandler = (_event: React.SyntheticEvent, value: boolean) => {
        setFieldValue({ key: "signUpForNewsletter", value: value ? "true" : "false" });
    };
    return (
        <Checkbox
            {...styles.signUpForNewsletterCheckboxField}
            labelPosition="right"
            variant="default"
            checked={signUpForNewsletter === "true"}
            onChange={signUpForNewsletterChangeHandler}
        >
            {label}
        </Checkbox>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(SignUpForNewsletter),
    definition: {
        group: "Contact Us",
        icon: "FormField",
        fieldDefinitions: [
            {
                name: fields.label,
                displayName: "Label",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Sign Up for Newsletter",
                isRequired: true,
            }
        ],
    },
};

export default widgetModule;